module.exports = __webpack_public_path__ + "img/LogoDashboard-17.5ef48dea.svg";